import React from "react";
import "./instructions.css";

export default function Instructions({ onClose = () => {}, onTutorial = null }) {
  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div
        className="modal-content instructions-modal"
        role="dialog"
        aria-modal="true"
        aria-label="How to play Erewhondle"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-btn" onClick={onClose} aria-label="Close instructions">✖</button>

        <h2>How to Play</h2>

        <p>
          Erewhon is known for selling everyday grocery items at <strong>shockingly high prices</strong>.
          In <strong>Erewhondle</strong>, your challenge is to guess what they’re charging for these items.
        </p>

        <p><strong>Each day features 5 items from different categories.</strong></p>
        <p>You get <strong>6 guesses per item</strong> to nail the price.</p>

        <p>After each guess, you'll see a colored box telling you how close you were:</p>
        <ul>
          <li>
            🟩 <strong>Green</strong> - within 5% of the actual price (or 25¢ on cheap items) - <strong>you win!</strong> 🎉
          </li>
          <li>
            🟨 <strong>Yellow</strong> - within 25% (or 75¢ on cheap items) - you're getting warm!
            <ul>
              <li className="arrow-fix"><strong>↑</strong> = go higher (your guess was too low)</li>
              <li className="arrow-fix"><strong>↓</strong> = go lower (your guess was too high)</li>
            </ul>
          </li>
          <li>
            🟥 <strong>Red</strong> - off by more than 25% - you'll still see{" "}
            <strong className="arrow-fix">↑</strong> or{" "}
            <strong className="arrow-fix">↓</strong> to point you in the right direction.
          </li>
          <li>After finishing each item, move on to the next.</li>
          <li>See your results summary after all 5 items!</li>
        </ul>

        <h3>⚖️ Weighted Items</h3>
        <p>
          Some items are priced by weight (e.g., per lb). For these items, guess the{" "}
          <strong>total estimated price</strong> shown in the image, not the price per pound.
          Look for the ⚖️ icon to know when an item is priced by weight.
        </p>

        <h3>Examples</h3>
        <div className="examples">
          <div className="example way-low">
            <code>$8.00</code> → <strong className="arrow-fix arrow-margin">↑</strong> (too low by more than 25%)
          </div>
          <div className="example high">
            <code>$14.00</code> → <strong className="arrow-fix arrow-margin">↓</strong> (too high but within 25%)
          </div>
          <div className="example correct">
            <code>$12.49</code> → <strong className="arrow-margin">✓</strong> (win! within 5%)
          </div>
        </div>

        <h3>🔥 Hard Mode</h3>
        <p>
          Tap the <strong>🔥</strong> button before guessing to enable hard mode for that item.
          The direction arrows are hidden - you only see the color of each guess.
        </p>
        <p>
          Hard mode locks in once you make your first guess on an item.
          Hard mode wins show up with a 🔥 in your share results!
        </p>

        <div className="footer-note">
          Come back daily to keep your streak alive!
        </div>

        <div className="feedback-link">
          Have feedback or found a bug?{" "}
          <a href="mailto:feedback@erewhondle.com?subject=Erewhondle Feedback">
            Let us know
          </a>
        </div>

        <div className="feedback-link">
          More games at{" "}
          <a href="https://medori.games" target="_blank" rel="noopener noreferrer">
            Medori&apos;s Games
          </a>
        </div>

        {onTutorial && (
          <button className="tutorial-launch-btn" onClick={onTutorial}>
            🎓 Play Interactive Tutorial
          </button>
        )}
      </div>
    </div>
  );
}
